import React from "react";
import { View } from "react-native";
import { TouchableOpacity } from "@/app/components/Buttons";
import { Text } from "@/app/components/Text";
import { reprintButtonStyles as styles } from "./styles";
import { useTranslateText } from "@/app/utils/translations";

type ReprintButtonProps = {
  onReprintPress: () => void;
};

const ReprintButton = ({ onReprintPress }: ReprintButtonProps): JSX.Element => {
  const { t } = useTranslateText();
  return (
    <View style={styles.reprintButtonContainer}>
      <TouchableOpacity
        onPress={onReprintPress}
        style={styles.reprintButtonButton}
      >
        <Text style={styles.reprintButton}>
          {t("tpos.orderHistoryArea.reprintReceipt")}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default ReprintButton;
